import React, { useState } from "react";

// import { OverlayTrigger, Tooltip } from "react-bootstrap";

// function ButtonWithTooltip({
//     btnColor,
//     buttonText,
//     tooltipTextBefore,
//     tooltipTextAfter,
//     onClick
// }) {
//     const tooltip = (
//         <Tooltip id={`${buttonText}-tooltip`}>
//             {/* <h5>Convert to Test</h5>
//         <hr /> */}
//             <strong>Before:</strong> {tooltipTextBefore}
//             <br />
//             {/* <p>After Clicking the button the above text will become like this!</p> */}
//             <strong>After:</strong> {tooltipTextAfter}
//         </Tooltip>
//     );

//     return (
//         <OverlayTrigger placement="top" overlay={tooltip}>
//             <button
//                 // className={btnColor === 'black-button' ? `btn ${btnColor} mx-1`: `btn btn-${btnColor} mx-1`}
//                 className={`btn ${btnColor} mx-1`}
//                 style={{ margin: "5px" }}
//                 onClick={onClick}
//             >
//                 {buttonText}
//             </button>
//         </OverlayTrigger>
//     );
// }

export default function TextForm(props) {
    const handleUpClick = () => {
        // console.log("Uppercase was Clicked " + text);
        let newText = text.toUpperCase();
        setText(newText);
        props.showAlert("Converted to Uppercase!", "success");
    };
    const handleDownClick = () => {
        let newText = text.toLowerCase();
        setText(newText);
        props.showAlert("Converted to Lowercase!", "success");
    };
    const handleSentenceCase = () => {
        let newText = text.replace(/(^|\. *)([a-z])/g, (match, separator, char) => {
            return separator + char.toUpperCase();
        });
        setText(newText);
        props.showAlert("Converted to Sentence Case!", "success");
    };
    const handleBold = () => {
        setBold(!bold);
        // if (bold){
        //     props.showAlert("Converted to Normal from!", "success");
        // }
        // else{
        //     props.showAlert("Converted to Bold!", "success");
        // }
        props.showAlert(bold ? 'Bold has been removed!' : 'Converted to Bold!', 'success')
    };
    const handleItalic = () => {
        setItalic(!italic);
        // if (italic){
        //     props.showAlert("Converted to Normal!", "success");
        // }
        // else{
        //     props.showAlert("Converted to Italic!", "success");
        // }
        props.showAlert(italic ? 'Italic has been removed!' : 'Converted to Italic!', 'success')
    };
    const handleUnderline = () => {
        setUnderline(!underline);
        props.showAlert(underline ? "Underline has been removed!" : "Underline has been added!", "success");
    };
    const handleStrikethrough = () => {
        setStrikethrough(!strikethrough);
        props.showAlert(strikethrough ? "Strikethrough has been removed!" : "Strikethrough has been added!", "success");
    };

    // const handleReplaceText = () => {
    //     const word = window.prompt('Enter the text to replace.');
    //     const newWord = window.prompt('Enter the text to replace with!');
    //     const newText = text.replaceAll(word, newWord);
    //     setText(newText);
    //     props.showAlert("Text Replaced!", "success");
    // };
    const handleReplaceText = () => {
        const textToReplace = window.prompt("Enter the text to replace:");
        if (textToReplace !== null && textToReplace.trim() !== "") {
          const replacementText = window.prompt("Enter the text to replace with:");
          if (replacementText !== null && replacementText.trim() !== "") {
            const replacedText = text.replaceAll(textToReplace, replacementText);
            setText(replacedText);
            props.showAlert("Text replaced!", "success");
          } else {
            props.showAlert("No replacement text provided!", "warning");
          }
        } else {
          props.showAlert("No text to replace provided!", "warning");
        }
      };
      


    const handleRemoveSpaces = () => {
        let newText = text.replace(/\s/g, "");
        setText(newText);
        if (newText === text) {
            props.showAlert("No Spaces found!", "warning");
        }
        else {
            props.showAlert("All Spaces has been removed!", "success");
        }
    };

    const handleRemoveExtraSpaces = () => {
        let newText = text.replace(/\s+/g, " ");

        if (newText.trim() === text.trim()) {
            // No extra spaces were found
            props.showAlert("No extra spaces found!", "warning");
        } else {
            // Extra spaces were found and removed
            setText(newText);
            props.showAlert("Extra spaces have been removed!", "success");
        }
    };

    const handleRemoveSpecialCharacters = () => {
        const regex = /[^a-zA-Z0-9 ]/g;
        const newText = text.replace(regex, "");

        if (newText === text) {
            props.showAlert("No special characters found!", "warning");
        } else {
            setText(newText);
            props.showAlert("Special characters removed!", "success");
        }
    }

    const handleReverseLetters = () => {
        let newText = text.split("").reverse().join("");
        setText(newText);
        // props.showAlert("Letters are reversed!", "success");
        // props.showAlert(newText.split("").length === 1 ? "One letter cannot be reversed!" : "Letters are reversed!", "success");
        if (newText.split("").length === 1) {
            props.showAlert("One letter cannot be reversed!", "warning");
        }
        else {
            props.showAlert("Letters are reversed!", "success");
        }
    };
    const handleReverseWords = () => {
        let newText = text.split(" ").reverse().join(" ");
        setText(newText);
        // props.showAlert(text.length === 1 ? "" : "Words are reversed!", "success");
        if (newText.split(" ").length === 1) {
            props.showAlert("One word cannot be reversed!", "warning");
        }
        else {
            props.showAlert("Words are reversed!", "success");
        }
    };
    const handleVowelsAndConsonants = (text) => {
        const vowels = "aeiouAEIOU";
        let countConsonants = 0;
        let countVowels = 0;

        for (let char of text) {
            if (vowels.includes(char)) {
                countVowels++;
            } else if (char.match(/[a-zA-Z]/)) {
                countConsonants++;
            }
        }
        setVowelCount(countVowels);
        setConsonantCount(countConsonants);
    };
    // const handleTest = () => {
    //     // TODO
    //     const vowels = 'aeiouAEIOU';
    //     let countV = 0;
    //     let countC = 0;
    //     for(let char of text){
    //         if(vowels.includes(char)){
    //             countV++;
    //         }
    //         else if(char.match(/[a-zA-Z]/)){
    //             countC++;
    //         }
    //     }
    //     let newText = `Consonants are ${countC} and Vowels are ${countV}`;
    //     // console.log();
    //     setText(newText)
    // };
    const handleClearText = () => {
        const confirmed = window.confirm("Are you sure you want to clear the textarea?");
        if (confirmed) {
            let newText = "";
            setText(newText);
            setVowelCount(0);
            setConsonantCount(0);
            props.showAlert("Textarea has been cleared!", "success");
        }
    };
    const handlePrint = () => {
        window.print();
        props.showAlert("Printed Successfully!", "success");
    };
    const handleCopyClick = () => {
        navigator.clipboard.writeText(text);
        props.showAlert("Copied to the Clipboard!", "success");
    };
    // Second Way of Copy to Clipboard
    // const handleCopyClick = () => {
    //     var text = document.getElementById("myBox");
    //     text.select();
    //     // text.setSelectionRange(0,text.value.length); // no need to write selection range the above line will do the needful
    //     navigator.clipboard.writeText(text.value);
    //     document.getSelection().removeAllRanges(); //  this line will remove the selection means when we are clicking copy the text is getting selected and we don't want that 
    // }

    const handlePasteClick = async () => {
        try {
            const clipboardText = await navigator.clipboard.readText();
            setText(text + clipboardText);
            props.showAlert("Pasted from Clipboard!", "success");
        } catch (error) {
            props.showAlert("Unable to paste from Clipboard!", "error");
        }
    };

    // const handleExtractNumbers = () => {
    //     const extractedNumbers = text.match(/[0-9]+/g);
    //     if (extractedNumbers !== null) {
    //       const updatedText = extractedNumbers.join(' ');
    //       setText(updatedText);
    //       props.showAlert("Numbers extracted!", "success");
    //     } else {
    //       props.showAlert("No numbers found in the text!", "warning");
    //     }
    //   };
    const handleExtractNumbers = () => {
        const extractedNumbers = text.match(/[0-9]+/g);
        if (extractedNumbers !== null) {
          const updatedText = extractedNumbers.join(' ');
          setText(updatedText);
          
          if (text.trim().match(/^[0-9\s]+$/)) {
            props.showAlert("Numbers are already extracted!", "warning");
          } else {
            props.showAlert("Numbers extracted!", "success");
          }
        } else if (text.trim() === "") {
          props.showAlert("No text in the textarea!", "warning");
        } else {
          props.showAlert("No numbers found in the text!", "warning");
        }
      };

    
    // const handleExtractLinks = () => {
    //     const linkRegex = /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/gim;
    //     const extractedLinks = text.match(linkRegex);
      
    //     if (extractedLinks !== null) {
    //       const updatedText = extractedLinks.join('\n');
    //       setText(updatedText);
    //       props.showAlert("Links extracted!", "success");
    //     } else if (text.trim() === "") {
    //       props.showAlert("No text in the textarea!", "warning");
    //     } else {
    //       props.showAlert("No links found in the text!", "warning");
    //     }
    //   };    

    const handleExtractLinks = () => {
        const linkRegex = /((?:https?|ftp|file):\/\/|www\.|ftp\.)?[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)+[^\s]*\b/g;
        const extractedLinks = text.match(linkRegex);
      
        if (extractedLinks !== null) {
          const updatedText = extractedLinks.join('\n');
          setText(updatedText);
          props.showAlert('Links extracted!', 'success');
        } else if (text.trim() === '') {
          props.showAlert('No text in the textarea!', 'warning');
        } else {
          props.showAlert('No links found in the text!', 'warning');
        }
      };

    // const handleExtractLinks = () => {
    //     const linkRegex = /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/gim;
    //     const extractedLinks = text.match(linkRegex);
      
    //     if (extractedLinks !== null) {
    //       const updatedText = extractedLinks.map((link) => {
    //         const url = link.trim().replace(/^.*?(?=https?:\/\/|www\.)/, '');
    //         return url;
    //       }).join('\n');
    //       setText(updatedText);
    //       props.showAlert('Links extracted!', 'success');
    //     } else if (text.trim() === '') {
    //       props.showAlert('No text in the textarea!', 'warning');
    //     } else {
    //       props.showAlert('No links found in the text!', 'warning');
    //     }
    //   };
      
      
      
      
  
    // Input      hellowww.google.com pranavhttps://www.india.com helloworld arya.com

    // Expected Output

    // www.google.com
    // https://www.india.com
    // arya.com
      
      
      
      
      
      
      

    const handleSpeech = () => {
        if (!text) return;

        const synth = window.speechSynthesis;
        const utterance = new SpeechSynthesisUtterance(text);
        synth.speak(utterance); // OR  window.speechSynthesis.speak(utterance);
        props.showAlert("Spoken Successfully!", "success");
    };
    // const handleGeolocation = () => {
    //     navigator.geolocation.getCurrentPosition(function (position) {
    //         console.log(
    //             "Latitude: " +
    //             position.coords.latitude +
    //             " Longitude: " +
    //             position.coords.longitude
    //         );
    //     });
    // };

    // const handleBattery = () => {
    //     if ("getBattery" in navigator) {
    //         navigator
    //             .getBattery()
    //             .then(function (battery) {
    //                 // const batteryLevel = battery.level * 100;
    //                 const status = `Battery level: ${battery.level * 100}%`;
    //                 setBatteryStatus(status);
    //                 console.log("Battery level: " + battery.level * 100 + "%");
    //             })
    //             .catch(function (error) {
    //                 console.error("Battery API Error:", error);
    //             });
    //     } else {
    //         console.error("Battery API is not supported by the browser.");
    //     }
    // };

    // const handleNetwork = () => {
    //     console.log("Device is " + (navigator.onLine ? "online" : "offline"));
    //     const status = navigator.onLine ? "online" : "offline";
    //     setNetworkStatus(status);
    // };
    const handleOnChange = (event) => {
        // console.log("OnChange");
        const newText = event.target.value;
        setText(newText);
        handleVowelsAndConsonants(newText);
    };

    const wordCount = (content) => {
        if (content === "") {
            return 0;
        }
        let arr = content.split(/\s+/);
        let len = arr.length;
        let emptyOrWhiteSpaceCount = 0;

        for (let i = 0; i < len; i++) {
            if (arr[i] === "" || arr[i] === " ") {
                emptyOrWhiteSpaceCount++;
            }
        }
        return len - emptyOrWhiteSpaceCount;
    };
    // one more way to do the above wordCount thing
    // const wordCount = (content) => {
    //     if(content.trim() === ""){
    //         return 0;
    //     }
    //     const words = content.trim().split(/\s+/);
    //     return words.length;
    // }

    // one another (third way) to do the same above wordCount thing
    // const wordCount = (text) => {
    //     let count = text.split(" ").filter((element) => {return element.length!==0}).length;
    //     return count;
    // }

    // window.onload = function () {
    //     handleBattery();
    //     handleNetwork();
    //     // handleGeolocation();
    // };
    const [text, setText] = useState("");
    // const [batteryStatus, setBatteryStatus] = useState(
    //     "Refresh the page to see Battery Status"
    // );
    // const [networkStatus, setNetworkStatus] = useState(
    //     "Refresh the page to see Network Status"
    // );
    const [vowelCount, setVowelCount] = useState(0);
    const [consonantCount, setConsonantCount] = useState(0);
    const [bold, setBold] = useState(false);
    const [italic, setItalic] = useState(false);
    const [underline, setUnderline] = useState(false);
    const [strikethrough, setStrikethrough] = useState(false);
    // text = "New Text"; // Wrong way to change the state

    return (
        <>
            <div>
                <h1 className="mb-3">{props.heading}</h1>
                <div className="mb-3">
                    <textarea
                        className="form-control"
                        id="myBox"
                        value={text}
                        onChange={handleOnChange}
                        rows="6"
                        placeholder={
                            bold || italic || strikethrough
                                ? ""
                                : "Enter Text Here - Buttons will start to appear when you type something to the textarea!"
                        }
                        style={{
                            backgroundColor: props.mode === "dark" ? "black" : "white",
                            color: props.mode === "dark" ? "white" : "black",
                            fontWeight: bold ? "bold" : "normal",
                            fontStyle: italic ? "italic" : "normal",
                            textDecoration:
                                underline && strikethrough
                                    ? "underline line-through"
                                    : underline
                                        ? "underline"
                                        : strikethrough
                                            ? "line-through"
                                            : "none",
                        }}
                    ></textarea>
                </div>
                <div>
                    <button
                        className={`btn ${props.btnColor} mx-1`}
                        style={{ margin: "5px" }}
                        onClick={handleUpClick}
                        // disabled={text.length===0} // i am not using this because if someone types space then also it enables the button
                        disabled={text.trim() === ""}
                    >
                        Convert To Uppercase
                    </button>
                    {/* <ButtonWithTooltip
                        btnColor={props.btnColor}
                        buttonText="Convert To Uppercase"
                        tooltipTextBefore="hello world"
                        tooltipTextAfter="HELLO WORLD"
                        onClick={handleUpClick}
                    /> */}
                    <button
                        className={`btn ${props.btnColor} mx-1`}
                        style={{ margin: "5px" }}
                        onClick={handleDownClick}
                        disabled={text.trim() === ""}
                    >
                        Convert To Lowercase
                    </button>
                    {/* <ButtonWithTooltip
                        btnColor={props.btnColor}
                        buttonText="Convert To Lowercase"
                        tooltipTextBefore="HELLO WORLD"
                        tooltipTextAfter="hello world"
                        onClick={handleDownClick}
                    /> */}
                    <button
                        className={`btn ${props.btnColor} mx-1`}
                        style={{ margin: "5px" }}
                        onClick={handleSentenceCase}
                        disabled={text.trim() === ""}
                    >
                        Convert To Sentence Case
                    </button>
                    {/* <ButtonWithTooltip
                        btnColor={props.btnColor}
                        buttonText="Convert To Sentence Case"
                        tooltipTextBefore="this app is good. this is created by Pranav Arya"
                        tooltipTextAfter="This app is good. This is created by Pranav Arya"
                        onClick={handleSentenceCase}
                    /> */}
                    <button
                        className={`btn ${props.btnColor} mx-1`}
                        style={{ margin: "5px" }}
                        onClick={handleBold}
                        disabled={text.trim() === ""}
                    >
                        Bold
                    </button>
                    {/* <ButtonWithTooltip
                        btnColor={props.btnColor}
                        buttonText="Bold"
                        tooltipTextBefore="#"
                        tooltipTextAfter="#"
                        onClick={handleBold}
                    /> */}
                    <button
                        className={`btn ${props.btnColor} mx-1`}
                        style={{ margin: "5px" }}
                        onClick={handleItalic}
                        disabled={text.trim() === ""}
                    >
                        Italic
                    </button>
                    {/* <ButtonWithTooltip
                        btnColor={props.btnColor}
                        buttonText="Italic"
                        tooltipTextBefore="#"
                        tooltipTextAfter="#"
                        onClick={handleItalic}
                    /> */}
                    <button
                        className={`btn ${props.btnColor} mx-1`}
                        style={{ margin: "5px" }}
                        onClick={handleUnderline}
                        disabled={text.trim() === ""}
                    >
                        Underline
                    </button>
                    {/* <ButtonWithTooltip
                        btnColor={props.btnColor}
                        buttonText="Underline"
                        tooltipTextBefore="#"
                        tooltipTextAfter="#"
                        onClick={handleUnderline}
                    /> */}
                    <button
                        className={`btn ${props.btnColor} mx-1`}
                        style={{ margin: "5px" }}
                        onClick={handleStrikethrough}
                        disabled={text.trim() === ""}
                    >
                        Strikethrough
                    </button>
                    {/* <ButtonWithTooltip
                        btnColor={props.btnColor}
                        buttonText="Strikethrough"
                        tooltipTextBefore="#"
                        tooltipTextAfter="#"
                        onClick={handleStrikethrough}
                    /> */}
                    <button
                        className={`btn ${props.btnColor} mx-1`}
                        style={{ margin: "5px" }}
                        onClick={handleCopyClick}
                        disabled={text.trim() === ""}
                    >
                        Copy To Clipboard
                    </button>
                    {/* <ButtonWithTooltip
                        btnColor={props.btnColor}
                        buttonText="Copy To Clipboard"
                        tooltipTextBefore="#"
                        tooltipTextAfter="#"
                        onClick={handleCopyClick}
                    /> */}
                    <button
                        className={`btn ${props.btnColor} mx-1`}
                        style={{ margin: "5px" }}
                        onClick={handleClearText}
                        disabled={text.trim() === ""}
                    >
                        Clear Text
                    </button>

                    <button
                        className={`btn ${props.btnColor} mx-1`}
                        style={{ margin: "5px" }}
                        onClick={handlePasteClick}
                    // disabled={text.trim() === ""}
                    >
                        Paste From Clipboard
                    </button>

                    {/* <ButtonWithTooltip
                        btnColor={props.btnColor}
                        buttonText="Clear Text"
                        tooltipTextBefore="#"
                        tooltipTextAfter="#"
                        onClick={handleClearText}
                    /> */}
                    
                    <button
                        className={`btn ${props.btnColor} mx-1`}
                        style={{ margin: "5px" }}
                        onClick={handleRemoveSpaces}
                        disabled={text.trim() === ""}
                    >
                        Remove All Spaces
                    </button>
                    {/* <ButtonWithTooltip
                        btnColor={props.btnColor}
                        buttonText="Remove All Spaces"
                        tooltipTextBefore="#"
                        tooltipTextAfter="#"
                        onClick={handleRemoveSpaces}
                    /> */}
                    <button
                        className={`btn ${props.btnColor} mx-1`}
                        style={{ margin: "5px" }}
                        onClick={handleRemoveExtraSpaces}
                        disabled={text.trim() === ""}
                    >
                        Remove Extra Spaces
                    </button>
                    {/* <ButtonWithTooltip
                        btnColor={props.btnColor}
                        buttonText="Remove Extra Spaces"
                        tooltipTextBefore="#"
                        tooltipTextAfter="#"
                        onClick={handleRemoveExtraSpaces}
                    /> */}

                    <button
                        className={`btn ${props.btnColor} mx-1`}
                        style={{ margin: "5px" }}
                        onClick={handleRemoveSpecialCharacters}
                        disabled={text.trim() === ""}
                    >
                        Remove Special Characters
                    </button>

                    <button
                        className={`btn ${props.btnColor} mx-1`}
                        style={{ margin: "5px" }}
                        onClick={handleReverseLetters}
                        disabled={text.trim() === ""}
                    >
                        Reverse Letters
                    </button>
                    {/* <ButtonWithTooltip
                        btnColor={props.btnColor}
                        buttonText="Reverse Letters"
                        tooltipTextBefore="#"
                        tooltipTextAfter="#"
                        onClick={handleReverseLetters}
                    /> */}
                    <button
                        className={`btn ${props.btnColor} mx-1`}
                        style={{ margin: "5px" }}
                        onClick={handleReverseWords}
                        disabled={text.trim() === ""}
                    >
                        Reverse Words
                    </button>
                    {/* <ButtonWithTooltip
                        btnColor={props.btnColor}
                        buttonText="Reverse Words"
                        tooltipTextBefore="#"
                        tooltipTextAfter="#"
                        onClick={handleReverseWords}
                    /> */}

                    <button 
                        className={`btn ${props.btnColor} mx-1`}
                        style={{ margin: "5px" }}
                        onClick={handleReplaceText}
                        disabled={text.trim() === ""}
                    >
                        Replace Text
                    </button>

                    <button 
                        className={`btn ${props.btnColor} mx-1`}
                        style={{ margin: "5px" }}
                        onClick={handleExtractNumbers}
                        disabled={text.trim() === ""}
                    >
                        Extract Numbers
                    </button>

                    <button 
                        className={`btn ${props.btnColor} mx-1`}
                        style={{ margin: "5px" }}
                        onClick={handleExtractLinks}
                        disabled={text.trim() === ""}
                    >
                        Extract Links
                    </button>

                    {/* <button className="btn btn-primary mx-1" onClick={handleTest}>
                    Test
                </button> */}
                    <button
                        className={`btn ${props.btnColor} mx-1`}
                        style={{ margin: "5px" }}
                        onClick={handleSpeech}
                        disabled={text.trim() === ""}
                    >
                        Text To Speech
                    </button>
                    {/* <ButtonWithTooltip
                        btnColor={props.btnColor}
                        buttonText="Text To Speech"
                        tooltipTextBefore="#"
                        tooltipTextAfter="#"
                        onClick={handleSpeech}
                    /> */}
                    <button
                        className={`btn ${props.btnColor} mx-1`}
                        style={{ margin: "5px" }}
                        onClick={handlePrint}
                        disabled={text.trim() === ""}
                    >
                        Print This Page
                    </button>
                    {/* <ButtonWithTooltip
                        btnColor={props.btnColor}
                        buttonText="Print This Page"
                        tooltipTextBefore="#"
                        tooltipTextAfter="#"
                        onClick={handlePrint}
                    /> */}
                </div>
                <br />
                {/* <div>
                    <button
                        className={`btn ${props.btnColor}  mx-1`}
                        style={{ margin: "5px" }}
                        onClick={handleGeolocation}
                    >
                        Check Location
                    </button>
                    <button
                        className={`btn ${props.btnColor}  mx-1`}
                        style={{ margin: "5px" }}
                        onClick={handleBattery}
                    >
                        Check Battery Status
                    </button>
                    <button
                        className={`btn ${props.btnColor}  mx-1`}
                        style={{ margin: "5px" }}
                        onClick={handleNetwork}
                    >
                        Check Network Status
                    </button>
                </div> */}
            </div>
            <div className="container my-1" style={{ fontSize: "20px" }}>
                <h2 className="my-1">Your Text Summary</h2>
                {/* <br /> */}
                <p>
                    <strong>{wordCount(text)}</strong> Words
                    and <strong>{text.length}</strong> characters | <strong>{vowelCount}</strong> Vowels | <strong>{consonantCount}</strong> Consonants
                </p>
                <p>
                    If you are a Slow Reader(<strong>125 wpm</strong>) it will take about{" "}
                    <strong>{0.008 * wordCount(text)}</strong> Minutes or{" "}
                    <strong>{0.48 * wordCount(text)}</strong> seconds to read the text.
                </p>
                <p>
                    If you are an Average Reader(<strong>300 wpm</strong>) it will take about{" "}
                    <strong>{0.0032 * wordCount(text)}</strong> Minutes or{" "}
                    <strong>{0.192 * wordCount(text)}</strong> seconds to read the text.
                </p>
                <br />
                {/* <h5>Battery Status - {batteryStatus}</h5>
                <br />
                <h5>Network Status - {networkStatus}</h5>
                <br /> */}
                <h2>Preview</h2>
                <p>
                    {text.length > 0
                        ? text
                        : "Enter Something in the textbox above to Preview it here"}
                </p>
            </div>
        </>
    );
}
